import { styled } from "@linaria/react"

import type { SyntheticEvent } from "react"

const urlRegex = /^https?:\/\/[^/]+/

export const FigmaEmbed = ({ url, height = 450 }: {
  url: string
  height?: number
}) => {
  const figmaEmbedUrl = `${url.replace(urlRegex, "https://embed.figma.com")}${url.includes("?") ? "&" : "?"}embed-host=matter-by-jetbrains`

  const stopEvent = (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <FigmaContainer>
      <FigmaIframe
        title="Figma preview"
        src={figmaEmbedUrl}
        allowFullScreen
        height={height}
      />
      {/* Dirty hack: Bottom overlay to block scroll/zoom/pan gestures over the lower area */}
      <BottomGestureBlocker
        aria-hidden
        onWheel={stopEvent}
        onTouchStart={stopEvent}
        onTouchMove={stopEvent}
        onPointerDown={stopEvent}
        onPointerMove={stopEvent}
      />
    </FigmaContainer>
  )
}

const FigmaContainer = styled.div`
  width: 100%;

  overflow: hidden;

  margin-top: 8px;

  border: 1px solid var(--separator-color);
  border-radius: var(--border-radius-8);

  position: relative;
`

const FigmaIframe = styled.iframe`
  display: block;

  width: 100%;

  border: none;
`

const BottomGestureBlocker = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 48px;
  background: transparent;
  pointer-events: auto;
  touch-action: none;
`
